import { render, staticRenderFns } from "./FlowBuilder.vue?vue&type=template&id=35aedd6a&scoped=true"
import script from "./FlowBuilder.vue?vue&type=script&lang=js"
export * from "./FlowBuilder.vue?vue&type=script&lang=js"
import style0 from "./FlowBuilder.vue?vue&type=style&index=0&id=35aedd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aedd6a",
  null
  
)

export default component.exports